var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"24","cy":"24","r":"24","fill":"currentColor","key":0}),React.createElement("path",{"d":"M29 15.5H19c-3 0-5 1.5-5 5v7c0 3.5 2 5 5 5h10c3 0 5-1.5 5-5v-7c0-3.5-2-5-5-5Zm.47 6.09-3.13 2.5c-.66.53-1.5.79-2.34.79-.84 0-1.69-.26-2.34-.79l-3.13-2.5a.77.77 0 0 1-.12-1.06c.26-.32.73-.38 1.05-.12l3.13 2.5c.76.61 2.05.61 2.81 0l3.13-2.5c.32-.26.8-.21 1.05.12.26.32.21.8-.11 1.06Z","fill":"#324843","key":1})]);
}

Email.defaultProps = {"width":"48","height":"48","fill":"none","viewBox":"0 0 48 48"};

module.exports = Email;

Email.default = Email;
